// Controllers are registered explicitly (no autoloading).

import { application } from "./application"

import PrintPreviewController from "./print_preview_controller"
application.register("print-preview", PrintPreviewController)
